import { Box } from "@chakra-ui/react";
import React, { useState } from "react";
import { useDelete, useGet } from "../../hooks/api-call";
import OrderListing from "./OrderListing";
import OrderSearchHeading from "./OrderSearchHeading";
import OrderFilters from "./OrderFilters";
import useCustomToast from "../../hooks/use-toast";
import { buildURLWithQueryParams } from "../../hooks/helper";

const BuyerOrderDashboard = () => {
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedOrderForEdit, setSelectedOrderForEdit] = useState(false);

  const { isLoading, responseData, fetchData } = useGet(`orders/search`);
  const { responseData: orderStageCount, fetchData: fetchStageWiseQuantity } = useGet(`orders/stageWiseQuantity`, [
    isDrawerOpen,
  ]);

  const { deleteData } = useDelete();
  const { showSuccessToast } = useCustomToast();

  const fetchOrdersData = (currentPage, details) => {
    const url = buildURLWithQueryParams("orders/search", {
      page: currentPage || activePage,
      size: pageSize,
      ...details,
    });
    fetchData(url);

    const stageUrl = buildURLWithQueryParams("orders/stageWiseQuantity", {
      ...details,
    });
    
    fetchStageWiseQuantity(stageUrl);
  };

  const handleRemoveOrder = (orderId) => {
    deleteData(null, `orders/${orderId}`);
    showSuccessToast("Success", `Order deleted successfully`);
    fetchOrdersData(activePage);
  };

  const handleEditOpen = (order) => {
    setIsDrawerOpen(true);
    setSelectedOrderForEdit(order);
  };

  return (
    <Box bg="gray.50">
      <Box pl="5" pr="5">
        <OrderSearchHeading setIsDrawerOpen={setIsDrawerOpen} />
        <OrderFilters fetchOrdersData={fetchOrdersData} />
        <OrderListing
          handleCreateNewOrder={() => setIsDrawerOpen(true)}
          handleRemoveOrder={handleRemoveOrder}
          isLoading={isLoading}
          orders={responseData?.content}
          activePage={activePage}
          setActivePage={setActivePage}
          pageSize={pageSize}
          totalPages={Math.ceil(
            (responseData?.numberOfElements || 0) / pageSize
          )}
          fetchTrucksData={fetchOrdersData}
          orderStageCount={orderStageCount}
        />
      </Box>
    </Box>
  );
};

export default BuyerOrderDashboard;
